export default "assets/images/shape-924b2bd1.png";